import { render, staticRenderFns } from "./PoActivityRecordRegist.vue?vue&type=template&id=1497749b&scoped=true"
import script from "./PoActivityRecordRegist.vue?vue&type=script&lang=js"
export * from "./PoActivityRecordRegist.vue?vue&type=script&lang=js"
import style0 from "./PoActivityRecordRegist.vue?vue&type=style&index=0&id=1497749b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1497749b",
  null
  
)

export default component.exports